<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="4" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/market/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/market/wap/banner.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">全球资讯 尽在此刻</h1>
        <h1 class="titles">全球资讯</h1>
        <h1 class="titles">尽在此刻</h1>
        <p class="banner-content-intro">国际级的视野 · 专家级的行情解读</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="sub-menu">
      <div v-for="item in menuList" :class="`sub-menu-item ${activeMenu === item.key && 'sub-menu-item-active'}`"
        :key="'sub-menu-' + item.key" @click="handleMenu(item)" :style="`
          ${activeMenu === item.key &&  activeMenu === '1' && 'border-top-left-radius: 4px;border-bottom-left-radius: 4px;'}
          ${activeMenu === item.key &&  activeMenu === '4' && 'border-top-right-radius: 4px;border-bottom-right-radius: 4px;'}
        `">
        <div>
          <img :src="activeMenu === item.key ? item.selectIcon : item.icon" alt="">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <div class="content-box">
      <keep-alive>
        <Market v-if="activeMenu === '1'"></Market>
      </keep-alive>
      <keep-alive>
        <market-second v-if="activeMenu === '2'"></market-second>
      </keep-alive>
      <keep-alive>
        <market-third v-if="activeMenu === '3'"></market-third>
      </keep-alive>
      <keep-alive>
        <market-fourth v-if="activeMenu === '4'"></market-fourth>
      </keep-alive>
    </div>

    <base-footer v-if="showType" />
  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import MarketSecond from './components/MarketSecond';
import MarketThird from './components/MarketThird';
import MarketFourth from './components/MarketFourth';
import MenuIcon1 from '@/assets/imgs/market/menu1.png'
import MenuIcon2 from '@/assets/imgs/market/menu2.png'
import MenuIcon3 from '@/assets/imgs/market/menu3.png'
import MenuIcon4 from '@/assets/imgs/market/menu4.png'
import MenuSelectIcon1 from '@/assets/imgs/market/menu-select1.png'
import MenuSelectIcon2 from '@/assets/imgs/market/menu-select2.png'
import MenuSelectIcon3 from '@/assets/imgs/market/menu-select3.png'
import MenuSelectIcon4 from '@/assets/imgs/market/menu-select4.png'
import Market from '@/component/market';

export default {
  name: 'Index',
  metaInfo: {
    title: '红狮金业实时行情资讯,现货黄金白银,黄金投资学习教程',
    meta: [
      { name: 'keywords', content: '红狮金业,黄金交易知识,贵金属交易技巧,贵金属投资方法,红狮课堂,现货黄金,现货白银,财经学院' },
      { name: 'description', content: '“红狮金业为用户提供实时行情资讯、专业解读，此外财经教学栏目为用户提供炒金知识,小白高阶等课程,专注于为客户提供更丰富的投资学习环境，包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
    ]
  },
  components: {
    BaseHeader,
    BaseFooter,
    MarketSecond,
    MarketThird,
    MarketFourth,
    Market
  },
  
  data() {
    return {
      activeMenu: this.$route.query.key || '1',
      menuList: [
        { name: '财经日历', key: '1', icon: MenuIcon1, selectIcon: MenuSelectIcon1 },
        { name: '热点新闻', key: '2', icon: MenuIcon2, selectIcon: MenuSelectIcon2 },
        { name: '市场快讯', key: '3', icon: MenuIcon3, selectIcon: MenuSelectIcon3 },
        { name: '专家评论', key: '4', icon: MenuIcon4, selectIcon: MenuSelectIcon4 },
      ],
      showType:true
    }
  },
  watch: {
    $route(nv){
      this.activeMenu = nv.query.key;
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
  },
  mounted() {

  },
  methods: {
    handleMenu(item) {
      this.activeMenu = item.key
    },
  },
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    position: relative;
      // padding-top: 80px;
    .banner-img {
      width: 100%;
      display: block;
    }
.banner-imgs {
      width: 100%;
      display: none;
    }
    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;
      .title{
        display: block;
      }
      .titles{
        display: none;
      }
      h1 {
        font-size: 68px;
        margin: 0;
      }
      &-intro {
        font-size: 18px;
      }
      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;
    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;
      span {
        color: #FA2314;
      }
    }
    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }
  
  .sub-menu {
    width: 1240px;
    position: relative;
    margin: -50px auto 80px;
    display: flex;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);

    &-item {
      cursor: pointer;
      width: 25%;
      color: #000;
      position: relative;
      font-size: 20px;
      padding: 20px 0;

      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        border-right: 1px solid #C9C9CF;

      }

      &:last-child {
        > div {
          border: none;
        }
      }

      img {
        margin-right: 10px;
      }
    }

    &-item-active {
      background: #FA2314;
      color: #FFFFFF;

      > div {
        border-right: 0px;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 0;
        height: 0;
        right: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #FA2314;
        margin: auto;
      }
    }

  }

}
@media screen and (max-width: 500px) {
  .app-container{
    .banner__layer{
      padding-top: 45px;
        .banner-img{
          display: none;
        }
        .banner-imgs{
          display: block;
          height: 500px;
       
        }
      
      .banner-content {
      position: absolute;
      top: 37%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      padding-top: 40px;
        background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
      // color: #000;
        color: #FFFFFF;

       .title{
        display: none;
      }
      .titles{
        color: #FFFFFF;
        display: block;
      }
      h1 {
        font-size: 58px;
        line-height: 77px;
        margin: 0;
        width: 100%;
        text-align: center;
        white-space: wrap;
      }
      &-intro {
        font-size: 14px;
        text-align: center;
      }
      &-download {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        &-btn {
          width: 180px;
          line-height: 34px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #0F0F11;
          color: #FFFFFF;

            padding: 2px 20px;
            font-size: 10px;
            &:first-child {
              border-right: 1px solid #fff;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 12px;
            }
          }
        }
      }
    }
        .banner-co {
          top: 33%;
        }
    
        }
    
        .bannerss {
          padding-top: 0;
        }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
    .title__layer {
      .title{
        display: none;
      }
      .titles{
        display: block;
      }
      h1{
        font-size: 36px;
        line-height: 48px;
      }
      p{
        font-size: 14px;
      }
    }
   
    .data-analyse-table{
      width: 100%;
    }
     .sub-menu {
      width: 80%;
    margin: -27px auto 40px;

      &-item {
        font-size: 12px;
        padding: 10px 0;

        > div {
          height: 17px;
        }
        img{
          display: none;
        }
      }
      &-item-active {
        &::after {
          bottom: -5px;
        }
      }
    }
    
    
  }
}
 // -------------------------小屏幕适配-------------------
 @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .app-container {
      background: #fafafa;
  
      .content-box {
        width: 1000px;
        margin: auto;
        box-sizing: border-box;
      }
  
      .banner__layer {
        position: relative;
        // padding-top: 80px;
  
        .banner-img {
          width: 100%;
          display: block;
        }
  
        .banner-imgs {
          width: 100%;
          display: none;
        }
  
        .banner-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 11;
          color: #FFFFFF;
  
          .title {
            display: block;
          }
  
          .titles {
            display: none;
          }
  
          h1 {
            font-size: 50px;
            margin: 0;
          }
  
          &-intro {
            font-size: 18px;
          }
  
          &-download {
            display: flex;
            align-items: center;
            margin-top: 50px;
  
            &-btn {
              width: 198px;
              line-height: 56px;
              color: #FFFFFF;
              background: #FA2314;
              border-radius: 4px;
              margin-right: 10px;
              cursor: pointer;
              text-align: center;
              font-size: 20px;
              font-weight: 700;
              display: inline-block;
            }
  
            &-text {
              display: flex;
              align-items: center;
  
              >div {
                display: flex;
                align-items: center;
                color: #FFFFFF;
                padding: 4px 40px;
  
                &:first-child {
                  border-right: 1px solid #0F0F11;
                }
  
                img {
                  width: 38px;
                  height: 38px;
                  margin-right: 12px;
                }
              }
            }
          }
        }
      }
  
      .title__layer {
        text-align: center;
        padding: 70px 0 50px;
  
        h1 {
          font-size: 46px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
  
          span {
            color: #FA2314;
          }
        }
  
        p {
          color: #0F0F11;
          font-size: 18px;
        }
      }
  
      .sub-menu {
        width: 1000px;
        position: relative;
        margin: -50px auto 80px;
        display: flex;
        background: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  
        &-item {
          cursor: pointer;
          width: 25%;
          color: #000;
          position: relative;
          font-size: 20px;
          padding: 20px 0;
  
          >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 44px;
            border-right: 1px solid #C9C9CF;
  
          }
  
          &:last-child {
            >div {
              border: none;
            }
          }
  
          img {
            margin-right: 10px;
          }
        }
  
        &-item-active {
          background: #FA2314;
          color: #FFFFFF;
  
          >div {
            border-right: 0px;
          }
  
          &::after {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 0;
            height: 0;
            right: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #FA2314;
            margin: auto;
          }
        }
  
      }
  
    }
 }
</style>